import React from 'react';
import { FileText, X } from 'lucide-react';
import Button from '../../../components/ui/Button';

const AGBModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 animate-fade-in">
      <div className="bg-card rounded-lg shadow-modal max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="inline-flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
              <FileText className="w-5 h-5 text-primary" />
            </div>
            <h3 className="text-xl font-heading font-semibold text-foreground">Allgemeine Geschäftsbedingungen</h3>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-muted transition-smooth" aria-label="Schließen">
            <X className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>
        
        <div className="p-6 md:p-8 space-y-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground leading-relaxed font-semibold">
              Allgemeine Geschäftsbedingungen für die Vermittlung und Vermarktung von THG-Quoten durch Grid Balance UG
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Stand: Januar 2026 | Geltungsbereich: B2C und B2B
            </p>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 1 Geltungsbereich und Vertragsgegenstand</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der Grid Balance UG, 79599 Wittlingen, und Kunden, die über die Online-Plattform von Grid Balance die Registrierung ihrer THG-Quote für Elektrofahrzeuge oder Ladepunkte beauftragen.</p>
              <p>(2) Grid Balance vermittelt die THG-Quote an einen Vermarktungspartner und übernimmt die Kommunikation, Prüfung der Daten sowie die Abwicklung gegenüber dem Vermarktungspartner.</p>
              <p>(3) Die Vermarktung der THG-Quote erfolgt ausschließlich nach Maßgabe des Treibhausgasquotengesetzes in der jeweils geltenden Fassung.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 2 Teilnahmevoraussetzungen</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Privatkunden müssen Halter des angemeldeten Elektrofahrzeugs sein oder vom Halter ausdrücklich bevollmächtigt worden sein.</p>
              <p>(2) Unternehmer bestätigen, dass die anmeldende Person vertretungsberechtigt ist und zur Übertragung von THG-Quoten bevollmächtigt wurde.</p>
              <p>(3) Der Kunde versichert, dass die THG-Quote für das angemeldete Fahrzeug im betreffenden Jahr nicht an Dritte abgetreten oder anderweitig vermarktet wurde.</p>
              <p>(4) Voraussetzung für die Teilnahme ist die wahrheitsgemäße Bereitstellung aller erforderlichen Dokumente.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 3 Aufschiebend bedingte Abtretung der THG-Quote</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Der Kunde überträgt Grid Balance das Recht zur Geltendmachung und Vermarktung der THG-Quote auf der Grundlage einer aufschiebenden Bedingung.</p>
              <p>(2) Die Abtretung wird erst wirksam, sobald Grid Balance von einem Vermarktungspartner eine Vergütung für die jeweilige THG-Quote tatsächlich erhält.</p>
              <p>(3) Erfolgt keine Vergütung, kommt die Abtretung nicht zustande. Der Kunde erhält in diesem Fall keine Leistung und Grid Balance hat keine weiteren Verpflichtungen.</p>
              <p>(4) Die THG-Quote darf im Fall eines Nichtzustandekommens der Abtretung vom Kunden anderweitig vermarktet werden.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 4 Vertragsbeziehung zu Vermarktungspartnern</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Grid Balance vermittelt die THG-Quote an Vermarktungspartner. Grid Balance wird hierbei als Vermittler und Abwickler tätig.</p>
              <p>(2) Die tatsächliche Auszahlung an Grid Balance hängt vollständig von der erfolgreichen Vermarktung durch den jeweiligen Vermarktungspartner ab.</p>
              <p>(3) Verzögerungen, Ablehnungen oder Stornierungen durch den Vermarktungspartner begründen keine Ansprüche des Kunden gegenüber Grid Balance.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 5 Vergütung</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Ein Anspruch des Kunden auf eine Auszahlung durch Grid Balance entsteht ausschließlich, wenn und sobald Grid Balance eine Vergütung von einem Vermarktungspartner erhalten hat.</p>
              <p>(2) Grid Balance schuldet weder eine Mindestvergütung noch einen bestimmten Auszahlungsbetrag. Die Vergütungshöhe richtet sich nach dem erzielten Marktpreis.</p>
              <p>(3) Grid Balance ist berechtigt, Vergütungen zu bündeln, zeitlich zu strukturieren und erst nach Eingang aller relevanten Zahlungen auszuzahlen.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 6 Pflichten des Kunden</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Der Kunde ist verpflichtet, vollständige und zutreffende Daten zur Verfügung zu stellen.</p>
              <p>(2) Bei fehlerhaften, widersprüchlichen oder missbräuchlichen Angaben kann Grid Balance die Bearbeitung verweigern oder abbrechen.</p>
              <p>(3) Änderungen bezüglich Haltereigenschaft, Fahrzeugstatus oder Fahrzeugwechsel sind unverzüglich mitzuteilen.</p>
              <p>(4) Für Unternehmen gilt zusätzlich: Das Unternehmen haftet für sämtliche Schäden, die aus fehlerhaften oder unbefugten Angaben entstehen.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 7 Haftung</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Grid Balance haftet nur für Vorsatz und grobe Fahrlässigkeit.</p>
              <p>(2) Eine Haftung für leichte Fahrlässigkeit besteht nur bei Verletzung wesentlicher Vertragspflichten, jedoch begrenzt auf den vorhersehbaren, vertragstypischen Schaden.</p>
              <p>(3) Grid Balance haftet nicht für: Ausbleiben einer Vergütung durch den Vermarktungspartner, Gesetzesänderungen, Marktpreisänderungen, Verzögerungen der Behörden, technische Störungen von Dritten, entgangenen Gewinn oder mittelbare Schäden.</p>
              <p>(4) Ansprüche des Kunden auf Schadenersatz sind ausgeschlossen, soweit dies gesetzlich zulässig ist.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 8 Vertragslaufzeit und Kündigung</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Der Vertrag endet automatisch, sobald die Vergütung an den Kunden ausgezahlt bzw. endgültig keine Vergütung erzielt wurde.</p>
              <p>(2) Eine ordentliche Kündigung vor diesem Zeitpunkt ist für beide Parteien möglich, sofern die THG-Quote noch nicht wirksam abgetreten wurde.</p>
              <p>(3) Eine Kündigung nach wirksamer Abtretung ist ausgeschlossen.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 9 Datenschutz</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Grid Balance verarbeitet personenbezogene Daten zur Durchführung des Vertrages gemäß DSGVO.</p>
              <p>(2) Eine Weitergabe erfolgt ausschließlich an Vermarktungspartner, gesetzlich zuständige Stellen und technische Dienstleister.</p>
              <p>(3) Ausführliche Informationen finden sich in der Datenschutzerklärung auf der Website von Grid Balance.</p>
            </div>
          </div>

          <div className="border-l-4 border-primary pl-6">
            <h3 className="text-lg font-heading font-bold text-foreground mb-3">Paragraph 10 Schlussbestimmungen</h3>
            <div className="space-y-3 text-muted-foreground">
              <p>(1) Es gilt deutsches Recht.</p>
              <p>(2) Ist der Kunde Kaufmann, ist Gerichtsstand der Sitz der Grid Balance UG.</p>
              <p>(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
            </div>
          </div>
        </div>
        
        <div className="sticky bottom-0 bg-card border-t border-border p-6 flex items-center justify-end">
          <Button variant="default" onClick={onClose} iconName="ArrowLeft" iconPosition="left">
            Zurück
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AGBModal;